export interface ArticleMeta {
  title: string;
  description: string;
  slug: string;
  date: string;
  readingTime: string;
}

export const articles: ArticleMeta[] = [
  {
    title: "What to Do When a Customer Claims Items Were Missing From a Shipment",
    description:
      "Step-by-step guidance for small business shippers on handling missing-item disputes — from pulling your shipping record to escalating with the carrier.",
    slug: "customer-claims-missing-items",
    date: "2026-04-07",
    readingTime: "6 min read",
  },
  {
    title: "How to Prove What You Shipped to a Customer (Without Expensive Software)",
    description:
      "Practical methods small businesses can use to document shipments and create verifiable proof of what left their dock — no enterprise software required.",
    slug: "how-to-prove-what-you-shipped",
    date: "2026-04-07",
    readingTime: "5 min read",
  },
  {
    title: "Chain of Custody Documentation for Small Business Freight",
    description:
      "What chain of custody means for B2B shippers, why it matters in freight disputes, and how to implement it without a logistics team.",
    slug: "chain-of-custody-documentation-small-business",
    date: "2026-04-07",
    readingTime: "7 min read",
  },
];
